/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PcmsHubReferralGraphStatusHistory } from './pcms-hub-referral-graph-status-history';
import { PcmsHubAdultReferralGraph } from './pcms-hub-adult-referral-graph';
import { PcmsHubReferralGraphContactAttempt } from './pcms-hub-referral-graph-contact-attempt';
import { PcmsHubReferralGraphWeeklyAttendance } from './pcms-hub-referral-graph-weekly-attendance';


export interface PcmsHubReferralGraphSnapshot { 
    adultReferral?: PcmsHubAdultReferralGraph | null;
    contactAttempts?: Array<PcmsHubReferralGraphContactAttempt>;
    crdReferralId?: string;
    lastModified?: string;
    /**
     * Optional for adults correlated by CRD referral GUID
     */
    pcmsReferralId?: number | null;
    referralStatus?: PcmsHubReferralGraphSnapshot.ReferralStatusEnum;
    referralStatusDate?: string;
    statusHistories?: Array<PcmsHubReferralGraphStatusHistory>;
    weeklyAttendances?: Array<PcmsHubReferralGraphWeeklyAttendance>;
}
export namespace PcmsHubReferralGraphSnapshot {
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


